import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'timeWindow'
})
export class TimeWindowPipe implements PipeTransform {

  constructor(@Inject('splitService') private splitService) {}

  transform(time: any, timeZoneId?: string): string {
    const from = _.get(time, 'notBefore') || _.get(time, 'startTime') || _.get(time, 'eta') || _.get(time, 'from');
    const to = _.get(time, 'notAfter') || _.get(time, 'endTime') || _.get(time, 'etd') || _.get(time, 'to');

    if (from && to) {
      const config = this.splitService.getDateAndTimeConfig();

      let isSameDate;
      let isSameTime;
      if (timeZoneId) {
        isSameDate = moment.tz(from, timeZoneId).isSame(moment.tz(to, timeZoneId), 'day');
        isSameTime = moment.tz(from, timeZoneId).isSame(moment.tz(to, timeZoneId), 'minute');
      } else {
        isSameDate = moment(from).isSame(moment(to), 'day');
        isSameTime = moment(from).isSame(moment(to), 'minute');
      }

      if (isSameDate && isSameTime) {
        return this.doDateFilter(from, config, timeZoneId) + ', ' + this.doTimeFilter(from, config, timeZoneId);
      }

      return isSameDate ?
        this.doDateFilter(from, config, timeZoneId) + ', ' + this.doTimeFilter(from, config, timeZoneId) + ' - ' + this.doTimeFilter(to, config, timeZoneId) :
        this.doDateFilter(from, config, timeZoneId) + ', ' + this.doTimeFilter(from, config, timeZoneId) + ' - ' + this.doDateFilter(to, config, timeZoneId) + ', ' + this.doTimeFilter(to, config, timeZoneId);
    } else {
      return '---';
    }
  }

  private doTimeFilter(date: any, config: any, timeZoneId: string): string {
    const format = config.time;
    if (timeZoneId) {
      return moment.tz(date, timeZoneId).format(format || 'HH:mm');
    } else {
      return moment(date).format(format || 'HH:mm');
    }
  }

  private doDateFilter(date: any, config: any, timeZoneId: string): string {
    const format = config.date;
    if (timeZoneId) {
      return moment.tz(date, timeZoneId).format(format || 'MM-DD');
    } else {
      return moment(date).format(format || 'MM-DD');
    }
  }
}
